import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/analytics/SectionView.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/blog/(programmes)/MandarinPostsFallback.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/blog/(programmes)/ProgrammePosts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/blog/(programmes)/ProgrammePostsFallback.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/AiContinuationButtons.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/components/WhatsAppButton.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
